import { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';

import videojs from 'video.js';

// import classes from './VideoInfo.module.css';

const VideoInfo = props => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const { options, onReady } = props;

  useEffect(() => {
    // Make sure Video.js player is only initialized once

    if (!playerRef.current) {
      const videoElement = videoRef.current;

      if (!videoElement) return;

      const player = (playerRef.current = videojs(
        videoElement,

        options,

        () => {
          videojs.log('player is ready');

          onReady && onReady(player);
        }
      ));

      // You could update an existing player in the `else` block here

      // on prop change, for example:
    } else {
      // const player = playerRef.current;
      // player.autoplay(options.autoplay);
      // player.src(options.sources);
    }
  }, [options, videoRef]);

  useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player) {
        player.dispose();

        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div data-vjs-player>
      {props.audioPlayer ? (
        <audio
          id="lessonCourse"
          ref={videoRef}
          className="video-js vjs-big-play-centered"
        />
      ) : (
        <video
          id="lessonCourse"
          ref={videoRef}
          className="video-js vjs-big-play-centered"
        >
          {props.hasCaption && (
            <track
              src={props.caption}
              kind="captions"
              srcLang="es"
              label="Español"
              default
            />
          )}
          {props.hasCaptionEn && (
            <track
              src={props.captionEn}
              kind="captions"
              srcLang="en"
              label="Inglés"
            />
          )}
        </video>
      )}
    </div>
  );
};

VideoInfo.propTypes = {
  // eslint-disable-next-line react/require-default-props
  openTrailer: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  onClose: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  trailerData: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  options: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  onReady: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  audioPlayer: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  caption: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  hasCaption: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  captionEn: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  hasCaptionEn: PropTypes.bool
};

export default VideoInfo;
